module.exports = __webpack_public_path__ + "static/header4-df3bf1d07e0de45803580242644e97a9.png";